var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({
    left: ((_vm.offset.x) + "px"),
    top: ((_vm.offset.y) + "px")
  })},_vm._l((_vm.list),function(data,index){return _c('div',{key:index,staticClass:"cursorView",style:({
      left: (((data.x + 105) * _vm.widthAmp) + "px"),
      top: (((data.y + 105) * _vm.widthAmp) + "px")
    })},[_c('div',{staticClass:"cursorView__icon"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }